<div class="layout-controls">
  <span class="layout-label">{{ 'translations.collections.layoutView' | transloco }}</span>
  <div class="layout-buttons">
    <ptl-button
      [highlighted]="currentLayoutView === 'CardView'"
      (click)="onLayoutViewChange('CardView')"
      [type]="'tertiary-neutral'"
      [size]="'m'"
      [icon]="DashboardSquareIcon"
    ></ptl-button>

    <ptl-button
      [highlighted]="currentLayoutView === 'SnakeView'"
      (click)="onLayoutViewChange('SnakeView')"
      [type]="'tertiary-neutral'"
      [size]="'m'"
      [icon]="ArrangeIcon"
    ></ptl-button>

    <ptl-button
      [highlighted]="currentLayoutView === 'ListView'"
      (click)="onLayoutViewChange('ListView')"
      [type]="'tertiary-neutral'"
      [size]="'m'"
      [icon]="LeftToRightListTriangleIcon"
    ></ptl-button>
  </div>
</div>
